import React from 'react'
import Articles from '../components/Articles'
import getArticles from '../api/getArticles'
import RatingCard from '../components/RatingCard'
import Skeleton from 'react-loading-skeleton'
import classNames from 'classnames'
import { usePortal } from '../hooks/usePortal'
import Breadcrumbs from '../components/Breadcrumbs'
import { createPortal } from 'react-dom'

const BREADCRUMBS = [
  {
    label: 'Главная',
    path: '/'
  },
  {
    label: 'Рейтинг',
    path: '/rating'
  }
]

const RatingPage: React.FC = () => {
  const [userData, setUserData] = React.useState<any>(null)
  const { portal } = usePortal()

  const handleOnLoad = ({ response, error }: any) => {
    if (!error) {
      setUserData(response?.data?.data?.user ?? null)
    }
  }

  return (
    <div className={'page'}>
      <Breadcrumbs className="page__breadcrumbs" breadcrumbs={BREADCRUMBS} />
      {portal &&
        createPortal(<Breadcrumbs breadcrumbs={BREADCRUMBS} />, portal)}

      <header className="page__head">
        <h1>Рейтинг</h1>
      </header>

      <div className="page__content">
        <Articles
          queryMode
          onLoad={handleOnLoad}
          noSections
          method={(options: any) => getArticles('/rating/list', options)}
          renderContent={(data, loading) => {
            return (
              <div className={'rating'}>
                {userData && (
                  <div className={'rating__user'}>
                    <p className={'text-secondary-color mb-md-5 mb-sm-4'}>
                      Ваше место в рейтинге:
                    </p>

                    <RatingCard {...userData}></RatingCard>
                  </div>
                )}
                {loading ? (
                  <div>
                    {Array.from({ length: 9 }).map((_, index) => (
                      <Skeleton
                        className={classNames({ 'mt-md-5 mt-sm-4': !!index })}
                        borderRadius={'2.4rem'}
                        key={index}
                        height={'7.2rem'}
                      ></Skeleton>
                    ))}
                  </div>
                ) : data.items.length ? (
                  <div>
                    {data.items.map((item: any, index: number) => (
                      <RatingCard
                        {...item}
                        className={classNames({ 'mt-md-5 mt-sm-4': !!index })}
                        key={item.id}
                      ></RatingCard>
                    ))}
                  </div>
                ) : (
                  'Нет данных'
                )}
              </div>
            )
          }}
        ></Articles>
      </div>
    </div>
  )
}

export default RatingPage
